<template>
  <v-container>
    <v-expansion-panels
      flat
      multiple
      :value="Object.keys(groupedFields).map((_, i) => i)"
    >
      <v-expansion-panel
        v-for="(group, groupName) in groupedFields"
        :key="groupName"
      >
        <v-expansion-panel-header
          v-if="groupName !== 'ungrouped'"
        >
          {{ groupName }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col
              v-for="field in group"
              :key="field.key"
              :cols="field.cols ? field.cols : 12"
            >

              <v-text-field
                v-if="(field.type == 'text' || field.type == 'password' || field.type == 'number')"
                :label="field.label"
                v-model="field.value"
                v-show="!field.hide"
                :type="field.type"
                :required="field.required ? field.required : false"
                :rules="field.rules && !field.readonly ? field.rules : []"
                :prepend-inner-icon="field.prependInnerIcon ? field.prependInnerIcon : null"
                :autofocus="field.autofocus ? true : false"
                :readonly="field.readonly ? true : false"
                :disabled="field.disabled ? true : false"
                @input="slugFormatValue(fieldsToShow[field.replicateValToIdx], $event)"
                v-maska="field.mask || null"
                :name="field.name || field.label"
                outlined
                dense
              >
                <template
                  v-if="activateFieldCheck"
                  v-slot:append-outer
                >
                  <v-checkbox
                    v-model="checkedFields"
                    :value="field.name"
                    :on-icon="activateFieldIcon"
                    class="prepend-checkbox"
                  ></v-checkbox>
                </template>
              </v-text-field>

              <v-text-field
                v-if="(field.type == 'slug')"
                :label="field.label"
                v-model="field.value"
                v-show="!field.hide"
                @input="slugFormatValue(field, $event)"
                type="text"
                :required="field.required ? field.required : false"
                :rules="field.rules && !field.readonly ? field.rules : []"
                :prepend-inner-icon="field.prependInnerIcon ? field.prependInnerIcon : null"
                :autofocus="field.autofocus ? true : false"
                :readonly="field.readonly ? true : false"
                :disabled="field.disabled ? true : false"
                :name="field.name || field.label"
                outlined
                dense
              >
                <template
                  v-if="activateFieldCheck"
                  v-slot:append-outer
                >
                  <v-checkbox
                    v-model="checkedFields"
                    :value="field.name"
                    :on-icon="activateFieldIcon"
                    class="prepend-checkbox"
                  ></v-checkbox>
                </template>
              </v-text-field>

              <v-textarea
                v-if="(field.type == 'textarea')"
                :label="field.label"
                v-model="field.value"
                v-show="!field.hide"
                :required="field.required ? field.required : false"
                :rules="field.rules && !field.readonly ? field.rules : []"
                :prepend-inner-icon="field.prependInnerIcon ? field.prependInnerIcon : null"
                :autofocus="field.autofocus ? true : false"
                :readonly="field.readonly ? true : false"
                :disabled="field.disabled ? true : false"
                :name="field.name || field.label"
                outlined
                dense
              >
                <template
                  v-if="activateFieldCheck"
                  v-slot:append-outer
                >
                  <v-checkbox
                    v-model="checkedFields"
                    :value="field.name"
                    :on-icon="activateFieldIcon"
                    class="prepend-checkbox"
                  ></v-checkbox>
                </template>
              </v-textarea>

              <v-select
                v-if="field.type == 'select'"
                v-model="field.value"
                v-show="!field.hide"
                :items="field.items"
                :item-text="field.itemText ? field.itemText : null"
                :item-value="field.itemValue ? field.itemValue : null"
                :chips="field.chips ? true : false"
                :label="field.label"
                :multiple="field.multiple ? true : false"
                :readonly="field.readonly ? true : false"
                :disabled="field.disabled ? true : false"
                :rules="field.rules && !field.readonly ? field.rules : []"
                @change="dispatchEvent(field, $event)"
                :name="field.name || field.label"
                outlined
                attach
              >
                <template
                  v-if="activateFieldCheck"
                  v-slot:append-outer
                >
                  <v-checkbox
                    v-model="checkedFields"
                    :value="field.name"
                    :on-icon="activateFieldIcon"
                    class="prepend-checkbox"
                  ></v-checkbox>
                </template>
              </v-select>

              <v-checkbox
                v-if="field.type == 'checkbox'"
                :label="field.label"
                v-model="field.value"
                v-show="!field.hide"
                :name="field.name || field.label"
                :value="field.value"
              >
                <template
                  v-if="activateFieldCheck"
                  v-slot:append-outer
                >
                  <v-checkbox
                    v-model="checkedFields"
                    :value="field.name"
                    :on-icon="activateFieldIcon"
                    class="prepend-checkbox"
                  ></v-checkbox>
                </template>
              </v-checkbox>

              <v-switch
                v-if="field.type == 'switch'"
                v-model="field.value"
                v-show="!field.hide"
                :label="field.label"
                :name="field.name || field.label"
              >
                <template
                  v-if="activateFieldCheck"
                  v-slot:append-outer
                >
                  <v-checkbox
                    v-model="checkedFields"
                    :value="field.name"
                    :on-icon="activateFieldIcon"
                    class="prepend-checkbox"
                  ></v-checkbox>
                </template>
              </v-switch>

              <SelectFileField
                v-if="field.type == 'select-file'"
                v-show="!field.hide"
                @selectNodes="setSelectFileValue(field, $event)"
                :value="field.value"
                :label="field.label"
                :icon="field.icon"
                :icon-color="field.iconColor"
                :accepts="field.accepts"
                :click-text="field.clickText"
                :select-text="field.selectText"
                :modal-title="field.modalTitle"
                :parent-node-id="field.parentNodeId"
                :multiple-selelect="field.multipleSelect"
                :name="field.name || field.label"
              >
                <template
                  v-if="activateFieldCheck"
                  v-slot:append
                >
                  <v-checkbox
                    v-model="checkedFields"
                    :value="field.name"
                    :on-icon="activateFieldIcon"
                  ></v-checkbox>
                </template>
              </SelectFileField>

              <JobCreationDiagram
                v-if="field.type == 'stepper-creation'"
                :current-step="parseInt(field.value)"
                :name="field.name || field.label"
                @step-clicked="onDiagramStepClicked(field, $event)"
              />

              <JobUnfoldDiagram
                v-if="field.type == 'stepper-unfold'"
                :current-step="parseInt(field.value)"
                :name="field.name || field.label"
                @step-clicked="onDiagramStepClicked(field, $event)"
              />

              <ClassificationField
                v-if="field.type == 'classification'"
                ref="postSubmitField"
                v-show="!field.hide"
                :field="field"
                :chips="field.chips ? true : false"
                :label="field.label"
                :multiple="field.multiple ? true : false"
                :readonly="field.readonly ? true : false"
                :disabled="field.disabled ? true : false"
                :rules="field.rules && !field.readonly ? field.rules : []"
                @change="dispatchEvent(field, $event)"
                :name="field.name || field.label"
                :activateFieldCheck="activateFieldCheck"
                :activateFieldIcon="activateFieldIcon"
                :nodeIds="nodeIds"
                outlined
              />

              <DeliverablesField
                v-if="field.type == 'deliverables'"
                ref="postSubmitField"
                :field="field"
                :job-data="entity"
                :readonly="field.readonly ? true : false"
                :user-acls="userAcls"
                :lanes="lanes"
                :current-pool-id="currentPoolId"
                :owner-pool-id="ownerPoolId"
                :user-lanes="userLanes"
                :app-config="appConfig"
                @openDeliverablesPanel="$emit('openDeliverablesPanel')"
              />

              <JobFilesField
                v-if="field.type == 'job-files'"
                @openFilesPanel="$emit('openFilesPanel', $event)"
                :field="field"
                :readonly="field.readonly ? true : false"
              />
            </v-col>

            <v-text-field
              v-show="false"
              v-model="checkedFields"
              name="field_check[]"
            ></v-text-field>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<style lang="scss" scoped>
  .prepend-checkbox {
    display: contents;
  }
  ::v-deep .v-expansion-panel-content__wrap, .v-expansion-panel-header {
    padding-left: 0;
    padding-right: 0;
  }
</style>

<script>
import Vue from 'vue'
import SelectFileField from '@/components/content/default/Form/SelectFileField'
import JobCreationDiagram from '@/components/job/JobCreationDiagram.vue'
import JobUnfoldDiagram from '@/components/job/JobUnfoldDiagram.vue'
import ClassificationField from '@/components/fields/ClassificationField.vue'
import DeliverablesField from '@/components/job/DeliverablesField.vue'
import JobFilesField from '@/components/job/JobFilesField.vue'

export default {
  name: 'DynamicFormContent',

  components: {
    SelectFileField,
    JobCreationDiagram,
    JobUnfoldDiagram,
    ClassificationField,
    DeliverablesField,
    JobFilesField,
  },

  props: {
    fields: {
      type: Array
    },

    entity: {
      type: Object,
      default: () => {}
    },

    nodeIds: {
      type: Array,
      default: () => []
    },

    activateFieldCheck: {
      type: Boolean,
      default: false
    },

    activateFieldIcon: {
      type: String,
      default: "$checkboxOn"
    },

    userAcls: {
      type: Array,
      default: () => []
    },

    lanes: {
      type: Array,
      default: () => []
    },

    ownerPoolId: {
      type: [Number, String],
      default: null
    },

    currentPoolId: {
      type: [Number, String],
      default: null
    },

    userLanes: {
      type: Array,
      default: () => []
    },

    appConfig: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      checkedFields: []
    }
  },

  methods: {
    dispatchEvent(field, value) {
      if (field.changeEvent) {
        this.$emit(field.changeEvent, value)
      }

      this.changeDependentItems(field, value)

      this.toggleVisibilityDenpendentItems(field, value)
    },

    changeDependentItems(dependencyField, value) {
      const dependentFields = this.fields.filter(f => f.dependencyFieldKey == dependencyField.name)

      if (dependentFields) {
        dependentFields.forEach(field => {
          field.items = [...field.itemsToFilter.filter(i => i.dependencyVals.includes(value))]

          field.value = null
        })
      }
    },

    toggleVisibilityDenpendentItems(dependencyField, value) {
      const dependentFields = this.fields.filter(f => f.visibilityDependencyFieldKey == dependencyField.name)

      if (dependentFields) {
        dependentFields.forEach((field) => {
          Vue.set(field, 'hide', ! field.visibilityDependencyVals.includes(value))
        })
      }
    },

    slugFormatValue(field, value) {
      if (!field || !field.replicable) {
        return
      }

      if (!value) {
        field.value = value

        return value
      }

      const formattedValue = value
            .toLowerCase()
            .replace(
              /(á|à|â|ã|é|è|ê|í|ï|ó|ô|õ|ö|ù|ú|ü|û|ñ|ç|·|\/|-|,|:|;)/gi,
              char => this.swapInvalidChars(char)
            )
            .replace(/[^\w ]+/g, '')
            .replace(/\s+/g, '_')

      field.value = formattedValue

      return formattedValue
    },

    swapInvalidChars(char) {
      const invalid = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/-,:;';
      const valid = 'aaaaaeeeeeiiiiooooouuuunc______';

      return valid.charAt(invalid.indexOf(char))
    },

    setSelectFileValue(item, data) {
      if (data.length == 0) {
        // Use Vue.set to guarantee reactivity even when `value` was not
        // present on the field object when Vue first observed it. Without
        // this, consumers that read the value from the DOM (e.g. NodeFieldsets
        // via `new FormData(...)`) would miss the change on the first select.
        Vue.set(item, 'value', null)
        return
      }

      if (item.multipleSelect) {
        Vue.set(item, 'value', data.map(node => node.node_id))
        return
      }

      if (Array.isArray(data) && data.length > 0) {
        Vue.set(item, 'value', data[0].node_id)
      }
    },

    convertStringRulesToArray(field) {
      if (field.rules && typeof field.rules === 'string') {
        field.rules = eval(field.rules)
      }

      return field
    },

    groupByCollapse(items) {
      return items.reduce((acc, item) => {
        const group = item.collapseGroup || 'ungrouped';
        if (!acc[group]) acc[group] = [];
        acc[group].push(item);
        return acc;
      }, {});
    },

    onDiagramStepClicked(item, step) {
      item.value = step
    },

    async postSubmitAction() {
      const fields = this.$refs.postSubmitField

      if (!fields) {
        return
      }

      let promises = []

      if (Array.isArray(fields)) {
        fields.forEach((field) => {
          promises.push(field.postSubmitAction())
        })
      } else {
        promises.push(fields.postSubmitAction())
      }

      await Promise.all(promises)
    },
  },

  computed: {
    fieldsToShow() {
      return this.fields.filter(f => !f.hide).map(f => {
        return this.convertStringRulesToArray(f)
      })
    },

    groupedFields() {
      return this.groupByCollapse(this.fieldsToShow)
    }
  },
}
</script>
